import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Coprporatecabserviceinolympiateckparkchennai() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Olympia Tech Park Chennai',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Olympia Tech Park Chennai',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Olympia Tech Park Chennai, catering to the transportation needs of IT companies, business centers, and corporate offices operating within and around the technology hub. Our fleet of well-maintained sedans, SUVs, MUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, clients, business delegates, and senior executives. Whether it is daily office commute, shift-based transportation, airport transfers, inter-office travel, client visits, business meetings, or VIP movement, we deliver smooth, hassle-free, and well-coordinated mobility solutions. With trained chauffeurs, GPS-enabled cars, flexible corporate rental plans, and dedicated service support, Pune Corporate Cars India Private Limited ensures a dependable, efficient, and premium travel experience for businesses in Olympia Tech Park Chennai.',

    top: 'Top Places to Visit in Chennai with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Marina Beach",
    "description": "Marina Beach is Chennai’s most famous landmark and one of the longest urban beaches in the world, stretching over 13 km along the Bay of Bengal. The beach is popular for morning jogs, evening strolls, kite flying, and street food like sundal, murukku, and fresh coconut water. It also hosts cultural events, festivals, and local gatherings, making it a hub of leisure, social activity, and city life."
  },
  {
    "title": "Kapaleeshwarar Temple",
    "description": "Kapaleeshwarar Temple in Mylapore is a classic example of Dravidian architecture, dedicated to Lord Shiva. Known for its vibrant gopuram, intricate carvings, and peaceful inner sanctum, the temple attracts devotees and tourists alike. The temple’s lively festivals, daily rituals, and traditional music and dance events offer a deep insight into Chennai’s spiritual and cultural heritage."
  },
  {
    "title": "Fort St. George",
    "description": "Fort St. George, established in 1644 by the British East India Company, is a historic landmark and administrative center in Chennai. It houses St. Mary’s Church, the Tamil Nadu Legislative Assembly, and a museum displaying colonial artifacts. Visitors can explore the fort’s ramparts, bastions, and exhibits, experiencing Chennai’s colonial history and military architecture."
  },
  {
    "title": "Santhome Cathedral Basilica",
    "description": "Santhome Cathedral Basilica, a majestic Gothic-style church, is built over the tomb of St. Thomas, one of Jesus Christ’s apostles. With beautiful stained-glass windows, elegant interiors, and serene surroundings, it attracts pilgrims and tourists alike. The church is both a spiritual center and a significant historical landmark, reflecting the Christian heritage of Chennai."
  },
  {
    "title": "Guindy National Park",
    "description": "Guindy National Park, located within Chennai city limits, is one of India’s smallest national parks. It is home to deer, blackbucks, exotic birds, and reptiles, and also features a Snake Park and Children’s Park. The park offers walking trails, picnic areas, and peaceful green spaces, making it ideal for families, wildlife enthusiasts, and students looking for nature amidst the urban environment."
  },
  {
    "title": "Valluvar Kottam",
    "description": "Valluvar Kottam is a monument dedicated to the famous Tamil poet and philosopher Thiruvalluvar. Its grand chariot-shaped auditorium and intricate stone carvings depict his literary works. The site serves as a cultural landmark and a center for literary and artistic appreciation, drawing visitors interested in Tamil culture, history, and architecture."
  },
  {
    "title": "Elliot’s Beach",
    "description": "Elliot’s Beach, located in Besant Nagar, is a serene coastal spot known for its clean sands, calm waters, and beautiful sunsets. Unlike Marina Beach, it is quieter and less crowded, making it ideal for evening walks, family outings, and leisure activities. Local cafés and eateries nearby add to the beach’s charm, offering a relaxing seaside experience."
  },
  {
    "title": "Theosophical Society",
    "description": "The Theosophical Society in Adyar is a sprawling campus with lush gardens, century-old trees, and historical buildings. It is a center for spiritual study, meditation, and philosophical discussions. Visitors can enjoy serene walks, birdwatching, and the famous Adyar Banyan Tree, experiencing a calm and reflective environment within the bustling city."
  },
  {
    "title": "Chennai Rail Museum",
    "description": "Chennai Rail Museum highlights the evolution of Indian railways, featuring vintage locomotives, carriages, photographs, and interactive exhibits. The museum offers miniature train rides, making it educational and entertaining for families, students, and railway enthusiasts. Visitors gain insight into India’s railway heritage while enjoying hands-on learning experiences."
  },
  {
    "title": "Semmozhi Poonga",
    "description": "Semmozhi Poonga is a botanical garden in central Chennai, featuring themed gardens, walking paths, landscaped lawns, and exotic plant species. It is perfect for morning walks, photography, and peaceful relaxation. The garden provides a refreshing green retreat amidst Chennai’s busy urban environment, ideal for families, nature lovers, and tourists."
  }
],


"services": [
{
"name": "Olympia Corporate Shuttle",
"description": "Olympia Corporate Shuttle provides high-capacity corporate shuttle solutions for companies operating inside and around Olympia Tech Park. Designed for large-scale workforce mobility, the service includes AC minibuses, smart route optimization, GPS tracking, digital attendance, and multi-shift operations. With strict safety protocols, trained drivers, and centralized fleet coordination, it ensures seamless and punctual mass employee transportation for IT and corporate offices."
},
{
"name": "Employee Shuttle Olympia",
"description": "Employee Shuttle Olympia offers structured shuttle services for employees working in Olympia Tech Park. The service features efficient route planning, real-time tracking, dedicated support teams, and safe multi-shift coverage. Designed for IT and corporate enterprises, it ensures smooth daily movement of staff while maintaining high safety, reliability, and operational consistency."
},
{
"name": "Office Commute Olympia Tech Park",
"description": "Office Commute Olympia Tech Park provides well-planned daily transportation for employees traveling to offices within Olympia Tech Park. With fixed and flexible routes, punctual dispatching, GPS-enabled vehicles, and professional chauffeurs, the service guarantees safe and efficient door-to-office commute for staff working across multiple shifts."
},
{
"name": "Business Taxi Olympia",
"description": "Business Taxi Olympia offers premium-quality corporate taxi services for meetings, airport transfers, client visits, and executive corporate travel. With top-tier sedans and SUVs, trained chauffeurs, real-time tracking, and instant booking availability, the service ensures a refined, reliable, and professional business travel experience within Chennai’s IT corridors."
},
{
"name": "Monthly Cab Olympia",
"description": "Monthly Cab Olympia provides long-term cab rental solutions specifically designed for companies located in Olympia Tech Park. The service includes dedicated chauffeur-driven vehicles, shift-based availability, GPS tracking, maintenance support, and flexible monthly plans, ensuring uninterrupted and cost-effective employee transport operations."
},
{
"name": "Best Corporate Cab Olympia",
"description": "Best Corporate Cab Olympia delivers premium corporate mobility with high-quality vehicles, experienced chauffeurs, strict safety adherence, and superior service delivery. Ideal for executives, managers, and premium corporate travel needs, it ensures comfortable rides, punctual service, and a top-tier travel experience across Olympia Tech Park and connected business zones."
},
{
"name": "Affordable Cab Olympia",
"description": "Affordable Cab Olympia provides budget-friendly yet reliable transportation solutions for companies and employees working around Olympia Tech Park. With efficient routing, trained drivers, regularly maintained vehicles, and cost-effective pricing, it ensures daily office commuting remains safe, smooth, and economical for all workforce categories."
},
{
"name": "Outstation Cab Olympia",
"description": "Outstation Cab Olympia offers safe and dependable long-distance travel solutions for business trips, executive movement, corporate visits, and intercity client travel. The service includes well-maintained sedans and SUVs, professional chauffeurs, interstate permits, GPS tracking, and full-trip management to ensure comfortable and timely outstation travel."
},
{
"name": "Corporate Fleet Olympia",
"description": "Corporate Fleet Olympia provides comprehensive fleet outsourcing and management services for organizations operating in Olympia Tech Park. Featuring sedans, SUVs, staff shuttles, and executive cars, the service includes driver management, scheduling, maintenance handling, compliance tracking, and scalable fleet availability for smooth day-to-day corporate mobility."
},
{
"name": "Sedan Cab Olympia",
"description": "Sedan Cab Olympia offers executive-grade sedan services suitable for managerial travel, airport transfers, client pick-ups, and comfortable daily office commutes. Vehicles feature plush interiors, superior comfort, and are operated by trained and verified chauffeurs, ensuring a reliable and premium travel experience for corporate users."
},
{
"name": "SUV Cab Olympia",
"description": "SUV Cab Olympia provides high-comfort, spacious SUVs ideal for senior executives, team travel, industrial visits, and long-distance corporate trips. With superior ride quality, advanced safety features, and well-trained drivers, it ensures a secure and premium travel experience across Chennai and beyond."
},
{
"name": "Staff Mobility Olympia",
"description": "Staff Mobility Olympia offers end-to-end mobility solutions for companies looking to streamline daily employee commuting. With route optimization, GPS-enabled monitoring, safety-compliant operations, digital records, and dedicated coordination teams, it guarantees efficient, safe, and scalable workforce transportation for Olympia Tech Park."
},
{
"name": "IT Park Cab Olympia",
"description": "IT Park Cab Olympia delivers specialized cab services for IT professionals traveling to and from Olympia Tech Park. With advanced dispatch systems, multi-shift compatibility, modern vehicles, and professional chauffeurs, it ensures safe, punctual, and comfortable daily commute solutions designed for the IT industry’s unique requirements."
},
{
"name": "Company Cab Olympia",
"description": "Company Cab Olympia offers complete corporate cab services including employee commute, executive mobility, and client transportation for companies in Olympia Tech Park. The service includes managed fleet operations, trained drivers, maintenance support, and GPS-enabled safety features to ensure dependable and efficient corporate travel."
},
{
"name": "Employee Transport Olympia",
"description": "Employee Transport Olympia provides structured and reliable daily transportation for employees traveling to Olympia Tech Park. The service covers multi-shift operations, optimized routing, real-time tracking, safety protocols, and professional driving standards to ensure employees enjoy safe, timely, and organized commuting every day."
}
],

"tableData": [
["Olympia Corporate Shuttle", "Employee Shuttle Olympia"],
["Office Commute Olympia Tech Park", "Business Taxi Olympia"],
["Monthly Cab Olympia", "Best Corporate Cab Olympia"],
["Affordable Cab Olympia", "Outstation Cab Olympia"],
["Corporate Fleet Olympia", "Sedan Cab Olympia"],
["SUV Cab Olympia", "Staff Mobility Olympia"],
["IT Park Cab Olympia", "Company Cab Olympia"],
["Employee Transport Olympia", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Olympia Tech Park Chennai",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited delivers dependable corporate cab services in Olympia Tech Park Chennai, ensuring smooth and efficient transportation for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Olympia Tech Park and nearby IT hubs, helping professionals reach offices, meetings, and client appointments on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our skilled chauffeurs provide safe, courteous, and disciplined travel, ensuring a secure and comfortable commuting experience for corporate staff."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all regularly sanitized, serviced, and maintained for reliable and comfortable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible cab rental plans tailored to meet the commuting needs of businesses and employees in Olympia Tech Park Chennai."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our support team operates round-the-clock to manage bookings, handle emergencies, and provide route adjustments for seamless corporate transportation."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles undergo regular sanitization and are equipped with modern safety features, ensuring safe, clean, and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate transportation is simplified with our streamlined booking process and reliable coordination, making employee travel management hassle-free."
  }
]






































  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Olympia Tech Park, Chennai?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies in Olympia Tech Park, Chennai.',
  },
  {
    question: 'What types of corporate cab services do you offer in Olympia Tech Park?',
    answer: 'We provide employee transportation, corporate pickups and drops, shuttle routes, airport transfers, and complete fleet management for IT and corporate offices.',
  },
  {
    question: 'Do you support daily employee commute services in Olympia Tech Park?',
    answer: 'Yes, we offer well-organized daily commute solutions with smart route optimization, timely pickups, and multi-shift transportation support.',
  },
  {
    question: 'How can companies book corporate cab services in Olympia Tech Park?',
    answer: 'Bookings can be done through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'What vehicles are available for corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, luxury cars, and tempo travellers depending on corporate requirements.',
  },
  {
    question: 'Do you provide long-term corporate transportation contracts for Olympia Tech Park companies?',
    answer: 'Yes, we offer monthly, quarterly, and annual corporate transportation contracts with flexible pricing structures.',
  },
  {
    question: 'Are your corporate cabs equipped with GPS tracking and safety features?',
    answer: 'All vehicles include GPS tracking, real-time monitoring, trained chauffeurs, and regular sanitization to ensure safe and secure travel.',
  },
  {
    question: 'Do you provide transportation for night and rotational shifts?',
    answer: 'Absolutely. We support transportation for night shifts, early morning shifts, weekend work hours, and rotational shift schedules.',
  },
  {
    question: 'What modes of payment are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, corporate invoicing, digital wallets, and credit/debit card payments.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Karthik Sundaram',
    feedback: 'Reliable and professional corporate cab service for our Olympia Tech Park team. Timely pickups and excellent driver behaviour.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shruti Narayanan',
    feedback: 'The daily commute service is extremely smooth and well-coordinated. Clean vehicles and consistent punctuality.',
    rating: 5,
  },
];







































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Olympia Tech Park Chennai",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-olympia-tech-park.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited provides premium corporate cab services in Olympia Tech Park Chennai, including corporate shuttles, employee transport, office commute, business cabs, monthly cab plans, outstation trips, corporate fleet solutions, and chauffeur-driven vehicles for companies operating in Olympia Tech Park.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-olympia-tech-park-chennai"
  }
};







  return (
    <div>

<Helmet>
  <title>Corporate Cab Service in Olympia Tech Park Chennai | Employee & Business Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Olympia Tech Park Chennai including corporate shuttles, employee transport, office commute, business cabs, monthly cab plans, outstation trips, and corporate fleet solutions."
  />

  <meta
    name="keywords"
    content="Olympia Corporate Shuttle, Employee Shuttle Olympia, Office Commute Olympia Tech Park, Business Taxi Olympia, Monthly Cab Olympia, Best Corporate Cab Olympia, Affordable Cab Olympia, Outstation Cab Olympia, Corporate Fleet Olympia, Sedan Cab Olympia, SUV Cab Olympia, Staff Mobility Olympia, IT Park Cab Olympia, Company Cab Olympia, Employee Transport Olympia"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/72.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Coprporatecabserviceinolympiateckparkchennai;